export default __webpack_public_path__ + "static/media/ic-home.faaa5859.svg";